<template>
	<div class="zzAdminBox" v-loading.fullscreen.lock="fullscreenLoading">
		<dialogBox :dialogFlag="delFlag" @qrsFn="delFn" rigTxt="确认" rigBg="#D33931" @callFn="delFlag = false" title="删除">
			<p style="text-align: center">删除后将无法恢复，是否确认删除</p>
		</dialogBox>
		<div class="zzAdminTabs">
			<div class="zzAdminTab">
				<div class="zzAdminItem" @click="tabFn('')" :class="status == '' ? 'active' : ''">全部</div>
				<div class="zzAdminItem" @click="tabFn(1)" :class="status == '1' ? 'active' : ''">待审核</div>
				<div class="zzAdminItem" @click="tabFn(3)" :class="status == '3' ? 'active' : ''">驳回</div>
				<div class="zzAdminItem" @click="tabFn(2)" :class="status == '2' ? 'active' : ''">通过</div>
			</div>
			<div class="zzAdminUp" @click="btns('upZz')">
				<img src="@/assets/img/shangchuan.png" class="upImg" alt="" />
				<span>上传资源</span>
			</div>
		</div>
		<div class="zzAdminConts">
			<div class="zzAdminCont" v-if="!perData.length">
				<el-empty description="暂无信息"></el-empty>
			</div>
			<div class="zzAdminCont" v-if="perData.length">
				<div class="zzAdminG" v-for="(item, index) in perData" :key="index">
					<div class="zzAdminItemImg" @click="decBtn(item)">
						<el-image :src="$imgFn(item.resourceFileName, 1)" lazy></el-image>
					</div>
					<div class="zzAdminItemP" @click="decBtn(item)">
						<div class="zzAdminItemTit">
							<div class="zzAdminItemStat" :class="{ zzAdminItemStat1: item.status == 1, zzAdminItemStat2: item.status == 3 }">
								{{ item.status == 1 ? '待审核' : item.status == 2 ? '通过' : item.status == 3 ? '驳回' : '通过' }}
							</div>
							<p>{{ item.title }}</p>
							<div class="zzAdminItemYuy">
								<img src="@/assets/img/jf.svg" alt="" />
								<span>{{ item.points || 0 }}</span>
							</div>
						</div>
						<div class="zzAdminItemJj">
							<div class="zzAdminItemJjI" :class="`zzAdminItemJjI${(index + 1) % 6}`" v-for="(i, index) in item.keywords?.split(',')" :key="index">
								{{ i }}
							</div>
						</div>
						<div class="zzAdminItemC" v-html="item.intro" :title="item.intro"></div>
						<div class="zzAdminItemFot">
							<div class="zzAdminItemk">
								<img src="@/assets/img/xiazai.svg" alt="" />
								<span>下载量：{{ item.download || 0 }}</span>
							</div>
							<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
							<!-- <div class="zzAdminItemk">
                  编写人：{{item.createNickName}}
                </div> -->
						</div>
					</div>
					<div class="zzAdminItemDel">
						<i class="el-icon-edit-outline" v-if="item.status == 3" @click="editFn(item)"></i>
						<i class="el-icon-delete" @click="delBtn(item)"></i>
					</div>
				</div>
			</div>
			<fenye v-if="perData.length" :total="total" ref="fybox" @dataFn="perList" />
		</div>
	</div>
</template>

<script>
import fenye from '@/components/pubComponents/fenye';
import dialogBox from '@/components/pubComponents/dialogBox';

export default {
	name: 'zzAdmin',
	data() {
		return {
			delFlag: false,
			status: '',
			perData: [],
			total: 0,
			fullscreenLoading: false,
			mutualAidResourceId: ''
		};
	},
	components: {
		fenye,
		dialogBox
	},
	methods: {
		editFn(item) {
			this.$emit('currCompBtn', 'upZz', {
				classType: 'zzAdmin',
				...item
			});
		},
		decBtn(item) {
			this.$router.push({
				path: './hbDec',
				query: {
					type: 5,
					flags: 1,
					txt: item.title,
					mutualAidResourceId: item.mutualAidResourceId,
					classType: 99,
					yzType: '',
					crumFlag: 1,
					tabFtxt: ['首页']
				}
			});
		},
		btns(cont) {
			this.$emit('currCompBtn', cont);
		},
		delBtn(item) {
			this.delFlag = true;
			this.mutualAidResourceId = item.mutualAidResourceId;
		},
		delFn() {
			if (this.mutualAidResourceId) {
				this.fullscreenLoading = true;
				this.$http.delete(`api/app/yydMutualAidResource/${this.mutualAidResourceId}`).then((res) => {
					this.fullscreenLoading = true;
					if (res.code == 200) {
						this.delFlag = false;
						this.$message({
							type: 'success',
							message: '删除成功'
						});
						this.init();
					}
				});
			}
		},
		tabFn(type) {
			this.status = type;
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydMutualAidResource/myList', {
					params: {
						status: this.status,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		},
		init() {
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		}
	},
	activated() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.zzAdminBox {
	flex: 1;
	margin-left: 10px;
	.zzAdminConts {
		background: #ffffff;
		border-radius: 0px 0px 6px 6px;
		padding: 0 15px;
		.zzAdminCont {
			margin-bottom: 30px;
			padding-bottom: 20px;
			min-height: 350px;
			.zzAdminG {
				display: flex;
				padding: 15px 0;
				border-bottom: 1px solid #f8f8f8;
				align-items: center;
				&:last-of-type {
					border-bottom: none;
				}
				.zzAdminItemImg {
					width: 100px;
					height: 100px;
					border-radius: 6px;
					margin-right: 10px;
					cursor: pointer;
				}
				.zzAdminItemP {
					width: 650px;
					cursor: pointer;
					.zzAdminItemJj {
						display: flex;
						align-items: center;
						.zzAdminItemJjI {
							padding: 0 10px;
							height: 20px;
							font-size: 12px;
							text-align: center;
							line-height: 20px;
							border-radius: 4px;
							margin-right: 10px;
							margin-bottom: 5px;
						}
						.zzAdminItemJjI0 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI1 {
							background: #fef7f0;
							color: #f7860f;
						}
						.zzAdminItemJjI2 {
							background: #f6fcf1;
							color: #5ec009;
						}
						.zzAdminItemJjI3 {
							background: #f1f7fe;
							color: #1675e5;
						}
						.zzAdminItemJjI4 {
							background: #fbf3ff;
							color: #bf2ff9;
						}
						.zzAdminItemJjI5 {
							background: #f2f7f3;
							color: #1d7b3a;
						}
					}
					.zzAdminItemFot {
						display: flex;
						align-items: center;
						.zzAdminItemk {
							display: flex;
							align-items: center;
							color: #8f9190;
							font-size: 12px;
							margin-right: 29px;
							img {
								width: 15px;
								height: 15px;
								margin-right: 4px;
							}
						}
					}
					.zzAdminItemC {
						color: #aeaeae;
						font-size: 14px;
						width: 647px;
						margin-bottom: 5px;
						overflow: hidden; /* 确保超出容器的内容被裁剪 */
						white-space: nowrap; /* 确保文本在一行内显示 */
						text-overflow: ellipsis; /* 超出部分显示省略号 */
					}
					.zzAdminItemTit {
						display: flex;
						align-items: center;
						margin-bottom: 6px;
						.zzAdminItemStat {
							padding: 0 10px;
							height: 20px;
							background: #1d7b3a;
							font-size: 14px;
							color: #fff;
							margin-right: 10px;
							border-radius: 4px;
							text-align: center;
							line-height: 20px;
						}
						.zzAdminItemStat1 {
							background: #f8a617;
						}
						.zzAdminItemStat2 {
							background: #fd691c;
						}
						p {
							font-size: 16px;
							color: #000000;
							font-weight: bold;
						}
						.zzAdminItemYuy {
							display: flex;
							align-items: center;
							color: #93571c;
							font-size: 14px;
							margin-left: 25px;
							img {
								width: 14px;
								height: 14px;
								margin-right: 5px;
							}
						}
					}
				}
				.zzAdminItemDel {
					flex: 1;
					margin-right: 32px;
					text-align: right;
					i {
						font-size: 20px;
						margin-left: 20px;
						color: #979797;
						cursor: pointer;
					}
				}
			}
		}
	}
	.zzAdminTabs {
		height: 50px;
		background: #ffffff;
		border-radius: 6px 6px 0px 0px;
		display: flex;
		justify-content: space-between;
		padding: 0 15px 0 26px;
		margin-bottom: 4px;
		.zzAdminTab {
			display: flex;
			font-size: 18px;
			color: #979797;
			align-items: center;
			.zzAdminItem {
				margin-right: 52px;
				cursor: pointer;
			}
			.active {
				color: #000;
				font-weight: bold;
			}
		}
		.zzAdminUp {
			display: flex;
			align-items: center;
			color: #1d7b3a;
			font-size: 14px;
			height: 100%;
			cursor: pointer;
			img {
				width: 16px;
				height: 16px;
				margin-right: 7px;
			}
		}
	}
}
</style>
